export enum AppPoolAction {
    Refresh = 'refresh',
    Recycle = 'recycle',
    Start = 'start',
    Stop = 'stop',
}
